import React from "react";

import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import GQL from "../assets/GraphQL.png";
import Python from "../assets/python.png";
import Cpp from "../assets/cpp-logo.png";
import FireBase from "../assets/firebase.png";
import Tailwind from "../assets/tailwind.png";
import Bootstrap from "../assets/bootstrap-logo.svg";
import Mongo from "../assets/mongo.png";
import SQL from "../assets/sql.png";
import Postgres from "../assets/postgres-elephant.png";
import Kotlin from "../assets/kotlin.png";
import Java from "../assets/java.png";

const Skills = () => {
  return (
    <div
      name="skills"
      className="w-full sm:h-[110vh] h-[250vh] bg-[#0a192f] text-gray-300"
    >
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-cyan-600">
            Skills
          </p>
          <p className="py-4">
            || These are some of the technologies I've worked with.
          </p>
        </div>
        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 mt-1 pb-[0.68rem] mx-auto"
              src={Cpp}
              alt="C++ icon"
            />
            <p className="my-4">C/C++</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={HTML} alt="HTML5 icon" />
            <p className="my-4">HTML5</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={CSS} alt="CSS3 icon" />
            <p className="my-4">CSS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:border-b-2 hover:shadow-blue-900 border-blue-800 hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={JavaScript} alt="JS icon" />
            <p className="my-4">JAVASCRIPT</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 pb-1 mx-auto"
              src={ReactImg}
              alt="React icon"
            />
            <p className="my-4">REACT</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Tailwind} alt="Tailwind icon" />
            <p className="my-4">TAILWIND</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 py-2 mx-auto"
              src={Bootstrap}
              alt="Bootstrap icon"
            />
            <p className="my-4">BOOTSTRAP</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 pb-1 mx-auto" src={Python} alt="Python icon" />
            <p className="my-4">PYTHON</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Node} alt="NodeJS icon" />
            <p className="my-4">NODE JS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={GQL} alt="GraphQL icon" />
            <p className="my-4">GraphQL</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={SQL} alt="SQL icon" />
            <p className="my-4">SQL</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-24 mt-1 mb-5 mx-auto"
              src={Mongo}
              alt="MongoDB icon"
            />
            <p className="my-4">MONGO DB</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 mx-auto my-4"
              src={Postgres}
              alt="Postgres icon"
            />
            <p className="my-4">Postgres</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Java} alt="Java icon" />
            <p className="my-4">JAVA</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-24 mt-2 mb-4 mx-auto"
              src={FireBase}
              alt="Firebase icon"
            />
            <p className="my-4">FIREBASE</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 mt-2 pb-4 mx-auto"
              src={Kotlin}
              alt="Kotlin icon"
            />
            <p className="my-4">KOTLIN</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
